const euroFormat = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const countFormat = new Intl.NumberFormat('de-DE', {
    maximumFractionDigits: 0,
});

/** Non-breaking space between € and number, matching utils/money.ts. */
export const formatEuro = (value: number | null | undefined): string =>
    value === null || value === undefined
        ? '-'
        : `€${'\u00A0'}${euroFormat.format(value)}`;

/** Percentages arrive pre-computed from the backend; null means "no basis" (e.g. previous year zero). */
export const formatPct = (value: number | null | undefined): string =>
    value === null || value === undefined
        ? '-'
        : `${euroFormat.format(value)}${'\u00A0'}%`;

export const formatCount = (value: number | null | undefined): string =>
    value === null || value === undefined ? '-' : countFormat.format(value);

export const MONTH_NAMES = [
    'Jänner',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
];

/** Trigger a browser download for a fetched Excel blob. */
export const downloadBlob = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
